export default "__VITE_ASSET__BUn8k2e4__"